import sanitizeHtml from 'sanitize-html';

export const appSanitizeHTML = (dirty?: string) => {
    return sanitizeHtml(dirty ?? '', {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'span', 'u', 's']),
        allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            '*': ['style', 'class'],
            img: ['src', 'alt', 'width', 'height', 'style'],
            li: ['data-list'],
            a: ['href', 'target', 'rel'],
        },
        allowedClasses: { '*': ['*'] },
        allowedStyles: {
            '*': {
                'color': [/.*/],
                'background-color': [/.*/],
                'text-align': [/.*/],
                'font-size': [/.*/],
                'font-family': [/.*/],
                'text-decoration': [/.*/],
            },
        },
        allowedSchemes: ['http', 'https', 'data'],
    });
}